import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding-top: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useState } from 'react';
import styled from 'styled-components';
import { size } from '@scp/ui-shared/theme/variables';
import { Icon } from '@scp/ui-shared/theme/icons';
import { IconButtonWithBadge } from '@scp/ui-shared/components/buttons';
import { SearchField } from '@scp/ui-shared/components/form-fields/SearchField';
import { CollapsibleWrapper } from '@scp/ui-shared/components/wrappers';
var TEXT = {
  TOGGLE_LABEL: function TOGGLE_LABEL(isOpen) {
    return isOpen ? 'Close Filters' : 'Open Filters';
  },
  TOGGLE_BADGE_LABEL: 'Has applied filters'
};
var Wrapper = styled.div(_templateObject());
var SearchRow = styled.div(_templateObject2());
var Content = styled.div(_templateObject3(), size.gutterSmall);
/**
 * @example ./__docs__/SearchWithFilters.md
 */

export var SearchWithFilters = function SearchWithFilters(_a) {
  var isFiltered = _a.isFiltered,
      children = _a.children,
      searchFieldProps = __rest(_a, ["isFiltered", "children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      filtersVisible = _useState2[0],
      setFilterVisibility = _useState2[1];

  return React.createElement(Wrapper, null, React.createElement(SearchRow, null, React.createElement(SearchField, Object.assign({
    clearable: true
  }, searchFieldProps)), React.createElement(IconButtonWithBadge, {
    onClick: function onClick() {
      return setFilterVisibility(!filtersVisible);
    },
    buttonTitle: TEXT.TOGGLE_LABEL(filtersVisible),
    badgeTitle: TEXT.TOGGLE_BADGE_LABEL,
    showBadge: isFiltered,
    "aria-expanded": filtersVisible,
    active: filtersVisible
  }, React.createElement(Icon, {
    name: "filter"
  }))), React.createElement(CollapsibleWrapper, {
    collapsed: !filtersVisible
  }, React.createElement(Content, null, children)));
};